<template>
    <div class="com-codics-ui-mystep-axad-body" :style="{
        '--size': size + 'px',
        '--width': (100 - 100 / data.length) + '%',
        '--checkWidth': (100 / data.length) * (value-1) + '%',
        '--checkLeft': (50 / data.length) + '%'
    }">
        <div class="com-codics-ui-mystep-axad-item" v-for="(item, index) in data" :key="index"
            :style="{ '--width': (100 / data.length) + '%', '--lineHeight': size * 2 + 'px' }">
            <div class="com-codics-ui-mystep-axad-item-circle iconfont"
                :style="{ '--circleWidth': size * 2 + 'px', '--fontSize': size + 'px', '--lineHeight': size * 2 - 2 + 'px', 'background': value > index ? '#F87147' : '#EBEBEB', 'color': value > index ? 'var(--mystep-circle-bg-checked-color)' : 'var(--mystep-circle-bg-color)', 'border-color':value > index ? 'var(--mystep-circle-l-checked-color)' : 'var(--mystep-circle-l-color)','color': value > index ? 'var(--mystep-circle-font-checked-color)' : 'var(--mystep-circle-font-color)'}"
                v-html="item.icon == null ? index + 1 : item.icon"></div>
            <div v-show="item.title != null" class="com-codics-ui-mystep-axad-item-title iconfont" v-html="item.title"
                :style="{ '--lineHeight': size * 3 + 'px', '--marginHeight': size * 2 + 'px', '--fontSize': size * 1.5 + 'px' }">
            </div>
            <div v-show="item.content != null" class="com-codics-ui-mystep-axad-item-content iconfont"
                :style="{ '--fontSize': size * 1.2 + 'px' }" v-html="item.content"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0
        },
        data: {
            type: Array,
            default: () => []
        },
        size: {
            type: Number,
            default: 9
        }
    }
}
</script>

<style>
:root {
    --mystep-bg-color: #F87147;
    --mystep-font-color: #333;
    --mystep-font-hint-color: #AAA;
    --mystep-l-color: #EBEBEB;
    --mystep-circle-bg-color: #FFF;
    --mystep-circle-l-color: #EBEBEB;
    --mystep-circle-font-color: #333;
    --mystep-circle-bg-checked-color: #F87147;
    --mystep-circle-l-checked-color: #F87147;
    --mystep-circle-font-checked-color: #FFF;
}

:root[data-theme="dark"] {}

.com-codics-ui-mystep-axad-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-ui-mystep-axad-body::before {
    content: '';
    height: 1px;
    width: var(--width);
    position: absolute;
    margin: auto;
    top: var(--size);
    left: 0;
    right: 0;
    background: #EBEBEB;
    background: var(--mystep-l-color);
    z-index: 1;
}

.com-codics-ui-mystep-axad-body::after {
    content: '';
    height: 1px;
    width: var(--checkWidth);
    max-width: var(--width);
    position: absolute;
    margin: auto;
    top: var(--size);
    left: var(--checkLeft);
    background: #EBEBEB;
    background: var(--mystep-bg-color);
    z-index: 1;
    transition: .3s;
}

.com-codics-ui-mystep-axad-item {
    height: fit-content;
    min-height: var(--lineHeight);
    width: var(--width);
    position: relative;
    float: left;
    box-sizing: border-box;
    z-index: 2;
}

.com-codics-ui-mystep-axad-item-circle {
    height: var(--circleWidth);
    width: var(--circleWidth);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    background: #FFF;
    background: var(--mystep-circle-bg-color);
    border-radius: 50%;
    box-sizing: border-box;
    border: 1px solid #EBEBEB;
    border: 1px solid var(--mystep-circle-l-color);
    line-height: var(--lineHeight);
    text-align: center;
    font-size: var(--fontSize);
    user-select: none;
    color: #333;
    color: var(--mystep-circle-font-color);
}

.com-codics-ui-mystep-axad-item-title {
    height: var(--lineHeight);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: var(--lineHeight);
    text-align: center;
    font-size: 12px;
    font-size: var(--fontSize);
    user-select: none;
    margin-top: var(--lineHeight);
    color: #333;
    color: var(--mystep-font-color);
}

.com-codics-ui-mystep-axad-item-content {
    height: fit-content;
    width: 80%;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    line-height: 20px;
    text-align: center;
    color: #AAA;
    color: var(--mystep-font-hint-color);
    font-size: 10px;
    font-size: var(--fontSize);
    user-select: none;
}
</style>